var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _g2, _g3, _g4, _g5, _path28, _path29, _path30, _path31, _g6, _g7, _g8, _g9, _g10, _path32, _path33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 299,
    viewBox: "0 0 316 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101.963,
    y: 144.306,
    width: 112.333,
    height: 8.641,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.662 298.843C244.737 298.843 315.325 288.858 315.325 276.542C315.325 264.226 244.737 254.241 157.662 254.241C70.5879 254.241 0 264.226 0 276.542C0 288.858 70.5879 298.843 157.662 298.843Z",
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.4648,
    width: 170.87,
    height: 282.307,
    rx: 14,
    fill: "#18BC46"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80.0684,
    y: 5.7782,
    width: 157.662,
    height: 270.75,
    rx: 11,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126.295,
    y: 0.00012207,
    width: 65.2112,
    height: 15.6837,
    rx: 6,
    fill: "#18BC46"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 141.154,
    y: 7.42908,
    width: 45.4002,
    height: 4.95275,
    rx: 2.47637,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 132.074,
    y: 7.42908,
    width: 4.95275,
    height: 4.95275,
    rx: 2.47637,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 134.549,
    y: 212.143,
    width: 89.1494,
    height: 4.95275,
    rx: 2.47637,
    fill: "#DFE2ED"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 134.549,
    y: 221.223,
    width: 34.6692,
    height: 4.95275,
    rx: 2.47637,
    fill: "#DFE2ED"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 95.752,
    y: 209.666,
    width: 30.5419,
    height: 18.9855,
    rx: 6,
    fill: "#DFE2ED"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 134.549,
    y: 241.034,
    width: 89.1494,
    height: 4.95275,
    rx: 2.47637,
    fill: "#DFE2ED"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 134.549,
    y: 250.114,
    width: 34.6692,
    height: 4.95275,
    rx: 2.47637,
    fill: "#DFE2ED"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 95.752,
    y: 238.558,
    width: 30.5419,
    height: 18.9855,
    rx: 6,
    fill: "#DFE2ED"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 93.2793,
    y: 31.3674,
    width: 100.706,
    height: 4.95275,
    rx: 2.47637,
    fill: "#DFE2ED"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 201.414,
    y: 31.3676,
    width: 23.1128,
    height: 4.95275,
    rx: 2.47637,
    fill: "#DFE2ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.418 162.242L220.18 167.477L219.553 182.812L99.722 177.908L100.418 162.242Z",
    fill: "#DB8B0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.57 120.833L118.014 170.45L202.092 174.783L204.648 125.167L120.57 120.833Z",
    fill: "#18BC46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M141.258 121.885L138.701 171.501L153.113 172.244L155.67 122.627L141.258 121.885Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M176.342 123.708L173.785 173.324L202.092 174.783L204.648 125.167L176.342 123.708Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.617 120.785L120.525 122.556L176.296 125.43L176.388 123.66L120.617 120.785Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.102 107.658L119.355 115.194L207.766 123.958L208.512 116.422L120.102 107.658Z",
    fill: "#18BC46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M140.714 109.713L139.967 117.249L154.328 118.673L155.075 111.137L140.714 109.713Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.19 113.119L174.443 120.655L207.761 123.958L208.507 116.422L175.19 113.119Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M179.254 105.498C179.466 103.399 178.836 101.301 177.502 99.666C176.168 98.0311 174.24 96.9929 172.141 96.7798L183.727 97.9254C184.768 98.0283 185.78 98.3355 186.703 98.8293C187.626 99.3232 188.443 99.994 189.107 100.804C189.771 101.613 190.269 102.546 190.572 103.548C190.876 104.55 190.979 105.602 190.876 106.644C190.773 107.686 190.466 108.697 189.972 109.621C189.479 110.544 188.808 111.361 187.998 112.025C187.189 112.689 186.257 113.187 185.255 113.491C184.253 113.794 183.201 113.898 182.159 113.795L174.226 113.011L170.609 112.637C172.7 112.829 174.783 112.186 176.402 110.849C178.021 109.512 179.046 107.588 179.254 105.498Z",
    fill: "#18BC46"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M179.254 105.498C179.466 103.399 178.836 101.301 177.502 99.666C176.168 98.0311 174.24 96.9929 172.141 96.7798L183.727 97.9254C184.768 98.0283 185.78 98.3355 186.703 98.8293C187.626 99.3232 188.443 99.994 189.107 100.804C189.771 101.613 190.269 102.546 190.572 103.548C190.876 104.55 190.979 105.602 190.876 106.644C190.773 107.686 190.466 108.697 189.972 109.621C189.479 110.544 188.808 111.361 187.998 112.025C187.189 112.689 186.257 113.187 185.255 113.491C184.253 113.794 183.201 113.898 182.159 113.795L174.226 113.011L170.609 112.637C172.7 112.829 174.783 112.186 176.402 110.849C178.021 109.512 179.046 107.588 179.254 105.498Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.118 96.7798L183.704 97.9253C182.662 97.8221 181.61 97.9252 180.608 98.2287C179.606 98.5322 178.674 99.0303 177.864 99.6943C177.055 100.358 176.384 101.176 175.89 102.099C175.397 103.022 175.09 104.034 174.987 105.076L174.203 113.011L162.617 111.805L163.401 103.87C163.62 101.775 164.66 99.8525 166.294 98.5234C167.928 97.1943 170.022 96.5673 172.118 96.7798Z",
    fill: "#18BC46"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M172.118 96.7798L183.704 97.9253C182.662 97.8221 181.61 97.9252 180.608 98.2287C179.606 98.5322 178.674 99.0303 177.864 99.6943C177.055 100.358 176.384 101.176 175.89 102.099C175.397 103.022 175.09 104.034 174.987 105.076L174.203 113.011L162.617 111.805L163.401 103.87C163.62 101.775 164.66 99.8525 166.294 98.5234C167.928 97.1943 170.022 96.5673 172.118 96.7798Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M159.531 95.5258L147.945 94.3199C150.048 94.5303 151.982 95.5663 153.322 97.2007C154.662 98.8352 155.3 100.935 155.095 103.038L154.311 110.973L165.897 112.179L166.681 104.244C166.784 103.202 166.681 102.15 166.378 101.148C166.074 100.146 165.576 99.2131 164.912 98.4034C164.248 97.5938 163.431 96.9229 162.508 96.4292C161.585 95.9354 160.573 95.6284 159.531 95.5258Z",
    fill: "#18BC46"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.531 95.5258L147.945 94.3199C150.048 94.5303 151.982 95.5663 153.322 97.2007C154.662 98.8352 155.3 100.935 155.095 103.038L154.311 110.973L165.897 112.179L166.681 104.244C166.784 103.202 166.681 102.15 166.378 101.148C166.074 100.146 165.576 99.2131 164.912 98.4034C164.248 97.5938 163.431 96.9229 162.508 96.4292C161.585 95.9354 160.573 95.6284 159.531 95.5258Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.814 102.677C151.025 100.573 152.06 98.6391 153.694 97.2985C155.329 95.9579 157.428 95.3204 159.531 95.5257L147.945 94.3198C145.841 94.1119 143.74 94.7485 142.106 96.0895C140.471 97.4306 139.436 99.3662 139.228 101.471C139.02 103.575 139.657 105.676 140.998 107.311C142.338 108.946 144.274 109.981 146.377 110.189L154.311 110.973L157.927 111.335C155.843 111.115 153.928 110.084 152.597 108.464C151.266 106.844 150.625 104.765 150.814 102.677Z",
    fill: "#18BC46"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M150.814 102.677C151.025 100.573 152.06 98.6391 153.694 97.2985C155.329 95.9579 157.428 95.3204 159.531 95.5257L147.945 94.3198C145.841 94.1119 143.74 94.7485 142.106 96.0895C140.471 97.4306 139.436 99.3662 139.228 101.471C139.02 103.575 139.657 105.676 140.998 107.311C142.338 108.946 144.274 109.981 146.377 110.189L154.311 110.973L157.927 111.335C155.843 111.115 153.928 110.084 152.597 108.464C151.266 106.844 150.625 104.765 150.814 102.677Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M191.288 86.8792L186.61 85.2512C185.067 80.6689 191.939 79.0168 190.396 74.3983L195.074 76.0263C196.617 80.6448 189.745 82.2968 191.288 86.8792Z",
    fill: "#18BC46"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.175 99.6618L111.052 102.604C106.917 101.965 108.388 96.0321 104.24 95.3689L107.351 92.4265C111.498 93.0897 110.027 99.0227 114.175 99.6618Z",
    fill: "#18BC46"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M114.175 99.6618L111.052 102.604C106.917 101.965 108.388 96.0321 104.24 95.3689L107.351 92.4265C111.498 93.0897 110.027 99.0227 114.175 99.6618Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M220.043 116.013L217.475 112.649C218.584 108.609 224.311 110.743 225.42 106.704L227.988 110.128C226.867 114.108 221.152 111.973 220.043 116.013Z",
    fill: "#18BC46"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M220.043 116.013L217.475 112.649C218.584 108.609 224.311 110.743 225.42 106.704L227.988 110.128C226.867 114.108 221.152 111.973 220.043 116.013Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M144.764 78.4382L141.858 79.1497C139.567 77.3288 142.509 74.2417 140.23 72.4208L143.136 71.7214C145.415 73.5423 142.473 76.6294 144.764 78.4382Z",
    fill: "#18BC46"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.483 137.08L107.399 139.926C105.76 142.338 102.456 139.648 100.817 142.06L99.9004 139.214C101.54 136.766 104.868 139.504 106.483 137.08Z",
    fill: "#18BC46"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M118.243 162.961L88.2544 161.669L95.2651 174.011L87.5363 182.215L106.342 183.031L106.081 189.048L210.332 193.572L210.593 187.555L230.216 188.407L221.183 179.475L230.934 167.86L202.195 166.579L209.436 174.453L106.821 170L118.243 162.961Z",
    fill: "#FFA412"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M229.393 259.378C227.154 264.817 213.978 264.443 200.173 258.749C186.369 253.056 176.98 244.03 179.219 238.591C179.745 237.334 181.244 232.624 182.743 231.976C187.888 229.798 197.682 234.691 208.286 239.067C218.161 243.119 229.453 245.763 231.206 251.122C232.259 254.383 230.031 257.828 229.393 259.378Z",
    fill: "#FFA412"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M231.206 251.121C232.046 255.386 230.193 257.432 229.393 259.377C228.593 261.322 226.253 262.599 222.982 263.045C222.573 263.114 222.16 263.161 221.746 263.186C219.238 263.334 216.721 263.201 214.241 262.791C213.887 262.791 213.533 262.68 213.168 262.619C210.258 262.097 207.39 261.358 204.589 260.411L203.577 260.066C202.452 259.671 201.298 259.236 200.143 258.76C198.989 258.283 197.895 257.747 196.811 257.27L195.879 256.825C193.326 255.562 190.866 254.12 188.516 252.509L187.686 251.922C185.635 250.472 183.756 248.793 182.085 246.917C181.832 246.634 181.599 246.36 181.376 246.077C179.199 243.321 178.338 240.687 179.199 238.591C179.766 237.243 180.981 232.634 182.723 231.965C184.866 231.362 187.133 231.362 189.276 231.965L190.289 232.209C195.353 233.505 201.733 236.392 208.246 239.077C215.923 242.248 225.008 245.54 229.464 249.339C229.729 249.562 229.983 249.798 230.223 250.048C230.579 250.379 230.908 250.738 231.206 251.121Z",
    fill: "#FFC430"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.797 231.338L190.331 232.188L182.107 246.907C181.854 246.624 181.621 246.35 181.398 246.067L189.298 231.945L189.916 230.851L190.797 231.338Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.015 237.344L188.538 252.54L187.707 251.952L196.134 236.878L197.015 237.344Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.602 246.056L204.591 260.411L203.578 260.066L211.681 245.52L212.602 246.056Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.346 242.004L196.828 257.27L195.896 256.825L204.465 241.468L205.346 242.004Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.05 248.832L214.242 262.792C213.887 262.792 213.533 262.68 213.168 262.619L221.159 248.326L222.05 248.832Z",
    fill: "black"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M231.146 254.637C228.907 260.077 215.893 259.864 202.078 254.161C188.264 248.458 178.885 239.442 181.134 234.002C183.382 228.562 196.386 228.785 210.201 234.478C224.016 240.171 233.384 249.167 231.146 254.637Z",
    fill: "#FFC430"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M226.445 252.661C224.865 256.5 214.717 255.964 203.789 251.456C192.86 246.948 185.285 240.171 186.865 236.332C188.445 232.492 198.593 233.029 209.531 237.537C220.469 242.045 228.035 248.822 226.445 252.661Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M299.195 210.206C302.801 214.856 295.934 226.11 284.115 235.258C272.295 244.405 259.808 248.052 256.212 243.362C255.382 242.288 252.019 238.692 252.222 237.01C252.9 231.469 262.005 225.411 271.08 218.381C279.527 211.837 287.416 203.348 292.936 204.493C296.289 205.232 298.172 208.889 299.195 210.206Z",
    fill: "#FFA412"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.935 204.533C297.057 205.931 297.907 208.585 299.194 210.206C300.48 211.827 300.429 214.532 299.194 217.601C299.052 217.976 298.88 218.351 298.697 218.736C297.588 220.988 296.229 223.108 294.646 225.057C294.434 225.341 294.201 225.614 293.968 225.898C292.063 228.17 289.991 230.296 287.769 232.259L286.989 232.938C286.088 233.718 285.136 234.498 284.154 235.258C283.171 236.018 282.189 236.737 281.196 237.416C280.923 237.618 280.629 237.811 280.356 238.003C277.989 239.591 275.512 241.006 272.942 242.238C272.628 242.4 272.324 242.531 272.03 242.673C269.747 243.73 267.352 244.525 264.89 245.044C264.526 245.125 264.171 245.185 263.817 245.236C260.343 245.753 257.628 245.236 256.241 243.403C255.35 242.248 251.957 238.895 252.25 237.061C252.78 234.894 253.906 232.918 255.501 231.358C255.724 231.105 255.967 230.851 256.221 230.588C259.877 226.799 265.538 222.737 271.109 218.432C277.682 213.367 285.055 207.096 290.554 205.131C290.886 205.009 291.225 204.904 291.567 204.817C292.016 204.689 292.472 204.594 292.935 204.533Z",
    fill: "#FFC430"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.687 229.757L256.193 230.588L264.863 245.044C264.498 245.125 264.144 245.185 263.789 245.236L255.474 231.338L254.826 230.325L255.687 229.757Z",
    fill: "black"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.982 227.346L272.915 242.237C272.601 242.399 272.297 242.531 272.004 242.673L263.111 227.863L263.982 227.346Z",
    fill: "black"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.283 218.169L287.74 232.27L286.96 232.948L278.412 218.685L279.283 218.169Z",
    fill: "black"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.176 222.433L281.17 237.415C280.896 237.618 280.603 237.81 280.329 238.003L271.295 222.95L272.176 222.433Z",
    fill: "black"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.392 211.331L294.616 225.057C294.404 225.34 294.171 225.614 293.938 225.898L285.521 211.857L286.392 211.331Z",
    fill: "black"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M281.048 231.283C292.86 222.132 299.517 210.946 295.917 206.297C292.317 201.648 279.823 205.298 268.012 214.449C256.2 223.599 249.543 234.786 253.143 239.434C256.743 244.083 269.237 240.433 281.048 231.283Z",
    fill: "#FFC430"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M279.582 228.463C288.931 221.221 294.446 212.685 291.901 209.399C289.356 206.113 279.715 209.32 270.366 216.562C261.018 223.805 255.503 232.34 258.047 235.626C260.592 238.913 270.234 235.706 279.582 228.463Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseSuccess);
export default __webpack_public_path__ + "static/media/PurchaseSuccess.341705f6c513d331ea320b8fc9682bf1.svg";
export { ForwardRef as ReactComponent };